export type QuotePurposeForBilling = {
    id: string
    exclusiveBillingType?: string | null
    directSaleCustomerType?: string | null
}

/** Alinha com `QuotePurpose.allowed_for_billing_type` no backend. */
export function getAllowedQuotePurposes<T extends QuotePurposeForBilling>(
    quotePurposes: T[] | undefined | null,
    billingType: string | undefined | null
): T[] {
    if (!quotePurposes?.length || !billingType) return []
    const normalizedSelection = billingType.toUpperCase()
    return quotePurposes.filter(purpose => {
        if (purpose.directSaleCustomerType) return true
        const restriction = purpose.exclusiveBillingType
        if (!restriction) return true
        return restriction.toUpperCase() === normalizedSelection
    })
}

/** Motivos com restrição explícita ao tipo de faturamento selecionado. */
export function getBillingExclusiveQuotePurposes<T extends QuotePurposeForBilling>(
    quotePurposes: T[] | undefined | null,
    billingType: string | undefined | null
): T[] {
    if (!quotePurposes?.length || !billingType) return []
    const normalizedSelection = billingType.toUpperCase()
    return quotePurposes.filter(purpose => {
        const restriction = purpose.exclusiveBillingType
        return restriction != null && restriction.toUpperCase() === normalizedSelection
    })
}

/** Motivos vinculados ao subtipo de venda direta (6A). */
export function getDirectSaleQuotePurposes<T extends QuotePurposeForBilling>(
    quotePurposes: T[] | undefined | null
): T[] {
    if (!quotePurposes?.length) return []
    return quotePurposes.filter(purpose => purpose.directSaleCustomerType)
}
